import {
  makeMapStateToProps,
  mapDispatchToProps,
  StateProps,
  DispatchProps,
  ContainerProps,
} from "./map-to-props-factory";
import { createUniversalConnector } from "../universal-connector-factory";
import { ComponentProps } from "./props";
import { withSportsbookBetslipContext, type SportsbookBetslipContext } from "../../context/sportsbook";

export default withSportsbookBetslipContext(({ config }: SportsbookBetslipContext) => ({ config }))(
  createUniversalConnector<StateProps | false, DispatchProps, ContainerProps, ComponentProps>(
    makeMapStateToProps,
    mapDispatchToProps,
  ),
);
